import angular from 'angular';
import uiRouter from 'angular-ui-router';
import emittentenComponent from './emittenten.component';
import emittentenService from './emittenten.service';

let emittentenModule = angular.module('emittenten', [
  uiRouter
])

.component('emittenten', emittentenComponent)
.service('emittentenService', emittentenService)

.name;

export default emittentenModule;



// WEBPACK FOOTER //
// ./client/app/common/forms/emittenten/emittenten.js